import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  credentialsRefreshed: {
    defaultMessage: 'Credentials refreshed successfully',
    id: 'CredentialsDirector.credentialsRefreshed',
  },
});
